module.exports = __webpack_public_path__ + "img/discount@2x.d78e8763.png";